<!-- Left Panel -->
<div id="storefiltermenu" [ngClass]="{'zsd-cust-filter-filtermenu-lg':windowSize >= 992}" class="zsd-cust-filter-filtermenu">
	<button class="btn zsd-cust-filter-button zsd-cust-filter-filtermenu-closebtn d-block d-xl-none d-lg-none" id="filterbackbutton" (click)="closeFilter()">
		<span class="fa fa-arrow-left fa-lg"></span>
	</button>
	<div class="card" id="zsd_cust_filter_panel">
		<div class="card-body pb-0" id="requested_items">
			<!-- Adding Filter as title at the top of the Store Filter-->
			<div class="card-title" id="zsd_cust_filter_text"><em class="fa fa-filter custom-filter"></em>{{ 'StoreFilter.storeFilter' | translate }}</div>

			<!-- Requested, Non-Requested and All Items -->
			<div id="req-nonreq">
				
				<div class="form-check" id="my_req_items">
					<input name="requested_radio" type="radio" class="form-check-input" value="my_requested_items" id="my_requested_items" [(ngModel)]="isRequestedItems">
					<label class="form-check-label" for="my_requested_items">{{ 'StoreFilter.myRequestedItemsHeader' | translate }}</label>
				</div>
			
				<div class="form-check" id="non_req_items">
					<input name="requested_radio" type="radio" class="form-check-input" value="non_requested_items" id="non_requested_items" [(ngModel)]="isRequestedItems">
					<label class="form-check-label" for="non_requested_items">{{ 'StoreFilter.nonRequestedItemsHeader' | translate }}</label>
				</div>
			
				<div class="form-check" id="all_items">
					<input name="requested_radio" type="radio" class="form-check-input" value="all_items" id="all_items" [(ngModel)]="isRequestedItems">
					<label class="form-check-label" for="all_items">{{ 'StoreFilter.allItemsHeader' | translate }}</label>
				</div>
			
			</div>
		</div>

		<!-- Store Categorization -->
		<div class="card-body zsd-cust-filter-bottom-line" id="categorization">
			<div class="card-title" id="zsd_cust_filter_category" data-toggle="collapse" data-target="#zsd_items_category_target"  [class.collapsed]="!categorizationChecked">{{ 'StoreFilter.storeCategorizationHeader' | translate }}
					<!-- <span ><img class="request-list-arrow" src="img/arrow.png" />
					</span> -->
			</div>
			<div id="zsd_items_category_target" [className]="categorizationChecked ? 'collpase show' : 'collapse'">
			<div class="search">
				<input type="text" class="form-control" type="search" id="zsd_cust_filter_placeholder_search" placeholder="{{ 'StoreFilter.search' | translate}}" [(ngModel)]="searchCategory">
			</div>

			<div id="zsd_cust_filter_category_list">
				<div class="form-check" *ngFor="let category of categoryResults | searchFilterPipe:'storeCategoryName':searchCategory">
					<label class="form-check-label" for="{{category.storeCategoryName}}">
						<input type="checkbox" class="form-check-input " value="categories" id="{{category.storeCategoryName}}" [(ngModel)]="category.checked">{{category.storeCategoryName}}
					</label>
				</div>
			</div>
			</div>
		</div>

		<!-- Store Capable Item Types -->
		<div class="card-body zsd-cust-filter-bottom-line" id="store_capable_item_types">
			<div class="card-title" id="zsd_cust_filter_item_types"  data-toggle="collapse" data-target="#zsd_item_types_target" [class.collapsed]="!itemTypeChecked">{{ 'StoreFilter.storeCapableItemTypesHeader' | translate }}
				<!-- <span><img class="request-list-arrow"  src="img/arrow.png" />
				</span> -->
			</div>
			<div id="zsd_item_types_target" [className]="itemTypeChecked ? 'collpase show' : 'collapse'">
			<div class="search">
				<input type="text" class="form-control" type="search" id="zsd_cust_filter_placeholder_search" placeholder="{{ 'StoreFilter.search' | translate}}" [(ngModel)]="searchItemType">
			</div>
			<div id="zsd_cust_filter_item_types_list">
				<div class="form-check" *ngFor="let itemType of storeCapableItemTypesResults | searchFilterPipe: 'itemTypename':searchItemType">
					<label class="form-check-label" for="{{itemType.itemTypename}}">
						<input type="checkbox" class="form-check-input" value="itemType" id="{{itemType.itemTypename}}" [(ngModel)]="itemType.checked">{{itemType.itemTypename}}
					</label>
				</div>
			</div>
			</div>

		</div>


		<div class="form-group text-center" id="zsd_cust_filter_button_id">
			<button type="submit" class="btn zsd-cust-filter-button" id="zsd_cust_filter_button_apply" (click)="applyFilter()">{{ 'StoreFilter.applyButton' | translate }}</button>
			<button type="button" class="btn zsd-cust-filter-button" id="zsd_cust_filter_button_clear" (click)="clearFilter()">{{ 'StoreFilter.clearButton' | translate }}</button>
		</div>

	</div>
</div>